import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { navLinks, contactInfo } from '../data';

export const Navbar = ({ onQuotationClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled || location.pathname !== '/' ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={isScrolled || location.pathname !== '/' ? "/images/logo/navbar-black.png" : "/images/logo/navbar-white.png"}
              alt="Aashi Constructions"
              className="h-9 sm:h-11 w-auto max-w-[200px] sm:max-w-[240px] object-contain transition-all duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
                {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => window.scrollTo(0, 0)}
                  className={`text-sm font-medium tracking-wide transition-colors duration-300 hover:text-brand-600 ${
                    location.pathname === link.path
                      ? isScrolled || location.pathname !== '/' ? 'text-brand-600 font-semibold' : 'text-white font-semibold'
                      : isScrolled || location.pathname !== '/' ? 'text-brand-800' : 'text-white/90'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
          </div>

          {/* Actions */}
          <div className="hidden md:flex items-center">
            <a href={`tel:${contactInfo.phones[0].replace(/\s/g, '')}`} className={`ml-3 transition-colors duration-300 ${
              isScrolled || location.pathname !== '/' ? 'text-brand-800' : 'text-white/80'
            }`}>
              <Phone className="w-5 h-5" />
            </a>
            <Button
              onClick={onQuotationClick}
              className="bg-brand-600 hover:bg-brand-700 text-white px-6 py-2 transition-all duration-300 hover:shadow-lg ml-6"
            >
              Get Quotation
            </Button>
          </div>

          {/* Mobile Actions */}
          <div className="md:hidden flex items-center space-x-2">
            <a href={`tel:${contactInfo.phones[0].replace(/\s/g, '')}`} className={`transition-colors duration-300 ${
              isScrolled || location.pathname !== '/' ? 'text-brand-800' : 'text-white/80'
            }`}>
              <Phone className="w-5 h-5" />
            </a>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`transition-colors duration-300 ${
                isScrolled || location.pathname !== '/' ? 'text-brand-900' : 'text-white'
              }`}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg max-h-screen overflow-y-auto">
          <div className="px-4 pt-2 pb-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => { setIsMobileMenuOpen(false); window.scrollTo(0, 0); }}
                className={`block px-4 py-3 text-base font-medium transition-colors duration-200 hover:bg-brand-50 hover:text-brand-600 rounded-lg ${
                  location.pathname === link.path ? 'text-brand-600 bg-brand-50' : 'text-brand-800'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Button
              onClick={() => {
                setIsMobileMenuOpen(false);
                onQuotationClick();
              }}
              className="w-full bg-brand-600 hover:bg-brand-700 text-white mt-4"
            >
              Get Quotation
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};
